/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Folder_RequiredInputs */

const fr_api_drive_folder_required = /** @type {(inputs: Api_Drive_Folder_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un dossier de publication dans les paramètres Drive.`)
};

const en_api_drive_folder_required = /** @type {(inputs: Api_Drive_Folder_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a publishing folder in Drive settings.`)
};

/**
* | output |
* | --- |
* | "Choose a publishing folder in Drive settings." |
*
* @param {Api_Drive_Folder_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_folder_required = /** @type {((inputs?: Api_Drive_Folder_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Folder_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_folder_required(inputs)
	return fr_api_drive_folder_required(inputs)
});